import { Box, Tooltip, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { RemainingTime } from 'shared/components/RemainingTime';
import { useStyles } from './MatchModalCountdown.styles';

interface MatchModalCountdownProps {
  date?: string;
  prefix?: string;
  tooltip?: string;
}

export const MatchModalCountdown: FC<MatchModalCountdownProps> = ({
  date,
  prefix = 'expires in',
  tooltip = 'The match must complete within',
}) => {
  const { classes } = useStyles();

  const [isCompleted, setIsCompleted] = useState(false);

  if (!date || isCompleted) {
    return null;
  }

  return (
    <Tooltip title={tooltip}>
      <Box className={classes.root}>
        <Typography variant="subtitle2" className={classes.prefix}>
          {prefix}
        </Typography>
        <Typography className={classes.time}>
          <RemainingTime date={date} variant="h4" onComplete={() => setIsCompleted(true)} />
        </Typography>
      </Box>
    </Tooltip>
  );
};
